<script setup lang="ts">
import KpSelectField from '@/components/KpSelectField.vue';
import { onMounted, ref, type Ref } from 'vue';

const value: Ref<any> = defineModel();

const props = withDefaults(
    defineProps<{
        label?: string;
        startYear?: number;
    }>(),
    { startYear: 2015 },
);

const years = ref<{ year: number }[]>([]);

onMounted(async () => {
    for (let i = new Date().getFullYear(); i >= props.startYear; i--) {
        years.value.push({ year: i });
    }
});
</script>
<template>
    <KpSelectField
        :label="label"
        v-model="value"
        :options="years"
        option-label="year"
        option-value="year"
    ></KpSelectField>
</template>
